import { render } from "./MobileAuth.vue?vue&type=template&id=a6085170"
import script from "./MobileAuth.vue?vue&type=script&lang=js"
export * from "./MobileAuth.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/pages/MobileAuth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6085170"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6085170', __exports__)) {
    api.reload('a6085170', __exports__)
  }
  
  module.hot.accept("./MobileAuth.vue?vue&type=template&id=a6085170", () => {
    api.rerender('a6085170', render)
  })

}


export default __exports__